export default __webpack_public_path__ + "media/images/mailer-new/welcome-icons/post_step-on-41828a125d6bcc89ee61f60ae0f7dca5.png";